import { render } from "./AddResep.vue?vue&type=template&id=024b9d48"
import script from "./AddResep.vue?vue&type=script&lang=js"
export * from "./AddResep.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__